<template>
  <div class="pages">
    <div class="pageContent infoPage">
      <div class="steps-background-wrapper" style="height: 0;padding:0;margin:0;visibility: hidden">
        <img class="steps-background" src="@/assets/img/stepsBg.png" alt="" />
      </div>
      <van-steps :active="stepActive" class="info-steps staff-steps" v-show="language === 'zh'" style="height: 0;padding:0;margin:0;visibility: hidden">
        <van-step class="staff-step">{{ $t('steps.person') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.contact') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.trip') }}</van-step>
      </van-steps>
      <van-steps :active="stepActive" class="info-steps staff-steps info-steps-English" v-show="language === 'en'" style="height: 0;padding:0;margin:0;visibility: hidden">
        <van-step class="staff-step">{{ $t('steps.person') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.contact') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.trip') }}</van-step>
      </van-steps>
      <div class="step-content" style="margin-top: 0; border-radius: 0">
        <person-info v-show="stepActive === 0" :formDisabled="formDisabled" ref="personInfo" />
        <div class="information-box button-group" v-if="btnShow && status !== 'ENABLE'">
          <van-button class="only-one" type="info" @click="goNext">{{ stepActive === 0 ? $t('form.label.submit') :
            $t('form.label.next') }}</van-button>
          <van-button plain type="info" v-show="stepActive > 0" @click="goPrev">{{ $t('form.label.previous') }}</van-button>
        </div>
      </div>
    </div>
    <!-- 参会须知 -->
    <van-dialog
      v-model="noticeShow"
      :title="'参会须知'"
      theme="round-button"
      :confirm-button-text="$t('read')"
      class="notice-dialog"
    >
      <div class="notice-dialog-body">
        <div v-html="confirm"></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { submitInfo } from '@/api/payment'
import { getConferenceInfo, getPaymentInstruction } from '@/api/conference'
import PersonInfo from './payment/personInfo.vue'
import { mapGetters } from 'vuex'
import MonitorKeyboard from '@/utils/monitorKeyboard.js'

export default {
  name: 'paymentRegis',
  components: { PersonInfo },
  data() {
    return {
      stepActive: 0,
      guestInfo: true,
      language: 'zh',
      form: {
        conferenceId: this.$route.params.conferenceId
      },
      btnShow: true,
      noticeShow: false,
      formDisabled: false,
      confirm: ''
    }
  },
  computed: {
    ...mapGetters(['status'])
  },
  mounted() {
    this.$changeLocale('zh');
    if (this.status === 'AUDIT') {
      this.finish()
      return
    }
    getPaymentInstruction({ conferenceId: this.$route.params.conferenceId }).then(res => {
      this.confirm = res.data.instructionCn
    })
    getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
      if (this.$checkTimeBetween(res.data.paymentRegisterStartTime, res.data.paymentRegisterEndTime)) {
        this.noticeShow = true
      } else {
        this.formDisabled = true
        this.btnShow = false
        this.$dialog.confirm({
          title: '温馨提示',
          message: '未到报名时间，无法提交数据',
          confirmButtonText: '确定',
          className: 'confirm-dialog',
          showCancelButton: false
        })
      }
    })
    this.language = this.$i18n.locale
    if (this.status) {
      this.getPersonInfo()
    } else {
      this.$nextTick(() => {
        this.$refs.personInfo.initForm(this.form)
      })
    }
  },
  methods: {
    getPersonInfo() {
      getPersonInfo().then(res => {
        this.form = res.data
        this.$nextTick(() => {
          this.$refs.personInfo.initForm(this.form)
        })
      })
    },
    goNext() {
      if (this.stepActive < 3) {
        if (this.stepActive === 0) {
          this.$refs.personInfo.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.personInfo.form)
            if (this.status !== 'ENABLE') {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                if (this.$checkTimeBetween(res.data.paymentRegisterStartTime, res.data.paymentRegisterEndTime)) {
                  this.submitInfo()
                } else {
                  this.formDisabled = true
                  this.btnShow = false
                  this.$notify('注册已结束')
                }
              })
            } else {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                // if (this.$checkTimeBetween(res.data.modificationStartTime, res.data.modificationEndTime)) {
                  this.updateInfo()
                // } else {
                //   this.$notify(this.$t3('不在修改信息时间内', 'Not in the time of information modification'))
                // }
              })
            }
          })
        }
      }
    },
    goPrev() {
    },
    // 提交全部信息
    submitInfo() {
      submitInfo(this.form).then(res => {
        if (res.success) {
          this.$store.commit('user/SET_NEED_UPDATE_INFO', false)
          this.finish()
        }
      })
    },
    // 修改部分信息
    updateInfo() {
      this.updateCount = 0
    },
    finish() {
      // TODO 跳转页面
      this.$router.push('mediaSuccess')
    },
    // 监听软键盘是否弹出
    getKeyboardState() {
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        // alert('键盘弹出')
        this.btnShow = false
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
        // alert('键盘收起')
        this.btnShow = true
      })
    },
    beforeDestroy() {
      this.monitorKeyboard.onEnd();
    }
  }
}
</script>